import React from "react";
import "./advert.css";
import image1 from "../../assets/shop-img-1.png";

const Advert2 = () => {
  return (
    <div className="bg-light my-5 p-2">
      <div className="container">
        <div className="row advert">
          <div className="advert-item advert-item-2 col-sm-6 d-flex align-items-center justif-content-center">
            <div className="text-center">
              <p>
                Contactless payment is now available on mobile! All you have to
                do is enter your information and hold your contactless card on
                the back of your phone
              </p>
            </div>
          </div>
          <div className="advert-item advert-item-3 col-sm-6 d-flex align-items-center justify-content-center">
            <img src={image1} alt="advertImage" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advert2;
